import { createSlice } from '@reduxjs/toolkit'
import { initialStateProps } from '../types/view360.types'

const initialState: initialStateProps = {
  selectedRelationshipData: null,
  relationships: null,
  sidebarState: null,
  layout: null,
  usedLayouts: null,
}

const view360Slice = createSlice({
  name: 'view360',
  initialState: initialState,
  reducers: {
    updateSidebarState: (state, action) => {
      state.sidebarState = action.payload
    },
    update360Layout: (state, action) => {
      state.layout = action.payload
    },
    updateSelectedRelationshipData: (state, action) => {
      state.selectedRelationshipData = action.payload
    },
    updateUsedLayouts: (state, action) => {
      state.usedLayouts = action.payload
    },
    clearSidebarState: (state) => {
      if (state.sidebarState) {
        state.sidebarState.state = false
      }
    },
    clear360Layout: (state) => {
      state.layout = null
    },
    clearSelectedRelationshipData: (state) => {
      state.selectedRelationshipData = null
    },
  },
})

export const {
  updateSidebarState,
  clearSidebarState,
  update360Layout,
  updateUsedLayouts,
  clear360Layout,
  updateSelectedRelationshipData,
  clearSelectedRelationshipData,
} = view360Slice.actions
export default view360Slice.reducer
